import { render } from "./AddPointView.vue?vue&type=template&id=49d98c22&scoped=true"
import script from "./AddPointView.vue?vue&type=script&lang=js"
export * from "./AddPointView.vue?vue&type=script&lang=js"

import "./AddPointView.vue?vue&type=style&index=0&id=49d98c22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d98c22"]])

export default __exports__